import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { Ref, watch } from "vue";
import { DetallesPedidoAction, FindOnePedidoAction } from "../actions";

export function usePedidosDetalles(id: Ref<string>) {
      const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["gepPedidoDetalles", id],
    queryFn: () => DetallesPedidoAction(id.value),
    enabled: () => !!id.value,
    staleTime: 60 * 1000,
  });
  // Si cambia el ID, hacer prefetch
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
         queryKey: ["gepPedidoDetalles", newId],
        queryFn: () => DetallesPedidoAction(newId),
      });
    }
  });
  return {
    ...query,
  };
}